
import route from './route';
import message from './message';
import layout from './layout';

export default {
  index: {
    whySelect: 'Why choose Prestige Student Apartments?',
    whySelectDesc1: 'The Prestige student housing series is dedicated to creating a consistent, high-quality accommodation experience for international students worldwide. No matter where you are,',
    whySelectDesc2: 'We provide you with a safe, comfortable, and home-like living environment with unified, standardized management and attentive service.',
    footerDesc: 'High-quality living spaces designed specifically for students, offering a comfortable, safe, and convenient accommodation environment.',
    copyright: '2026 PRESTIGE 32, All rights reserved.',
    advantagesTitle: 'Apartment Advantages',
    advantagesSubTitle: 'From hardware to services, everything is thoughtfully designed — emphasizing comfort, convenience, and transparency. Perfect for supporting your studies and internships in Hong Kong.',
    roomTypeTitle: 'Exquisite room',
    roomVisit: 'Room Tour',
    locationTitle: 'Location',
    arriveInstitutionTime: 'Transportation Time to Campus',
    arriveTransportTime: 'Transportation Time',
    feeTitle: 'Fee Details',
    contactUsTitle: 'Book a Visit or Learn More Information',
    contactUsDesc: 'Schedule a Visit or Learn More',
    download: 'Download Materials',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    contactUsFirstName: 'First name',
    contactUsLastName: 'Last name',
    contactUsName: 'Name',
    contactUsPhone: 'Phone number',
    contactUsEmail: 'Email',
    contactUsQuest: 'Your enquiry',
    contactUsSend: 'Send',
    firstnamePlaceholder: 'Please enter your last name',
    lastnamePlaceholder: 'Please enter your first name',
    phonePlaceholder: 'Please enter your phone number',
    emailPlaceholder: 'Please enter your email address',
    userQuestionPlaceholder: 'Please enter your questions',
    menuHome: 'Home',
    menuFeatures: 'Facilities',
    menuRoomType: 'Room Types',
    menuLocation: 'Location',
    menuContactUs: 'Contact Us',
    quickLinks: 'Quick Links',
    contactInformation: 'Contact Information',
    footerAddress: 'Room 502, 5/F, Building 2W, Phase 1, Hong Kong Science Park',
    footerPhone: '(852)2110 3835',
  },
  route,
  message,
  ...layout,
};
